import { NotFound } from './NonFound/NotFound'
import { Unauthorized } from './Unautorized/Unauthorized'

export const Errors = {
  NotFound,
  Unauthorized
}
